import { ThemePropsType, themes, ThemeVariablesWrapper } from '@getvim/components-hooks-use-theme';
import React, { FC, useEffect, useMemo, useState } from 'react';
import EligibilityContainer from './atomic/EligibilityContainer';
import { GlobalContext, GlobalContextProps } from './context';

import '@getvim/atomic-ui/assets/styles/main.less';
import { useApi } from '@getvim/internal-vim-os-sdk/react';
import { ActivationStatus } from '@getvim/internal-vim-os-sdk/types';
import './App.less';
import { useAppConfig } from './context';
import { useEnrichLoggerMetadata } from './hooks/useEnrichLoggerMetadata';
import { usePatientLookupSharedService } from './hooks/usePatientLookupSharedService';

const App: FC = () => {
  useEnrichLoggerMetadata();

  const config = useAppConfig();

  const { setActivationStatus } = useApi();

  const patient = usePatientLookupSharedService();

  const [globalContext, setGlobalContext] = useState<GlobalContextProps>({
    featureFlags: {},
  });

  useEffect(() => {
    setGlobalContext((context) => ({
      ...context,
      featureFlags: {},
    }));
  }, []);

  useEffect(() => {
    if (!patient) {
      setActivationStatus(ActivationStatus.DISABLED);
    }
  }, [patient, setActivationStatus]);

  const theme: ThemePropsType = useMemo(
    () => (config?.organization?.theme && themes[config.organization.theme]) ?? themes.vimConnect,
    [config?.organization?.theme],
  );

  return (
    <GlobalContext.Provider value={globalContext}>
      <ThemeVariablesWrapper theme={theme}>
        {patient ? <EligibilityContainer patient={patient} /> : null}
      </ThemeVariablesWrapper>
    </GlobalContext.Provider>
  );
};

export default App;
